import Language  from "@/scripts/Language";
import { ref, Ref } from "vue";
import chineseLanguage from "./ChineseLanguage";
const templang: Ref<Language> = ref(chineseLanguage)
export default templang